import React, { useEffect } from 'react';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import {
  CheckIcon,
  CloserIcon,
  ContainerCloseModal,
  Content,
  CopyLink,
  GoToSimulator,
  Title,
} from './ModalSuccess.styles';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    width: '350px',
    height: '260px',
    borderRadius: '5px',
    transform: 'translate(-50%, -50%)',
  },
  overlay: { zIndex: 3, background: '#00000070' },
};

interface ModalSuccessProps {
  link: string;
  open: boolean;
  setOpen: (value: boolean) => void;
}

export function ModalSuccess({ link, open, setOpen }: ModalSuccessProps): JSX.Element {
  useEffect(() => {
    Modal.setAppElement('body');
  }, []);
  
  const toastSuccessClipboard = () =>
    toast.success('Copiado para área de transferência!', {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      pauseOnFocusLoss: false,
    });

  async function clipboardCopy() {
    await navigator.clipboard.writeText(link);
    toastSuccessClipboard();
  }

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <Modal isOpen={open} style={customStyles} onRequestClose={closeModal}>
      <Content>
        <ContainerCloseModal>
          <CloserIcon size={20} onClick={closeModal} />
        </ContainerCloseModal>
        <CheckIcon size={50} />
        <Title>Simulador publicado com sucesso!</Title>

        <CopyLink onClick={clipboardCopy}>Copiar link</CopyLink>
        <GoToSimulator target="_blank" href={link} onClick={closeModal}>
          Acessar o simulador
        </GoToSimulator>
      </Content>
    </Modal>
  );
}
